<template>
  <v-app>
    <AppBar></AppBar>
    <v-fade-transition>
      <router-view/>
    </v-fade-transition>
  </v-app>
</template>

<script>
// @ is an alias to /src
import AppBar from '@/components/AppBar.vue'

export default {
  name: 'App',
  components: {
    AppBar
  }
}
</script>

<style lang="scss">
.py-10{
  padding-top: 100px
}
</style>
